import { useMemo } from 'react'
import { useNewTranslation } from './index'

export const useLocationTranslation = (rankName: string | undefined) => {
    const [t] = useNewTranslation()
    const copiesList: { [key: string]: string } = {
        city: t('campaignEditor.requirement.selectCity'),
        district: t('campaignEditor.requirement.selectDistrict'),
        region: t('campaignEditor.requirement.selectRegion'),
        province: t('campaignEditor.requirement.selectProvince'),
        state: t('campaignEditor.requirement.selectState'),
        town: t('campaignEditor.requirement.selectTown'),
    }
    const assembleTitle = (rankName: string | undefined) => {
        let title = ''
        if (rankName) {
            rankName.split(/[/]/).forEach((place: string, index: number) => {
                if (index === 0 || index === rankName.length) {
                    title = title + copiesList[place]
                } else {
                    title = title + ' / ' + copiesList[place]
                }
            })
        }
        return title
    }
    const locationName = useMemo(() => {
        return assembleTitle(rankName)
    }, [rankName, t])

    return locationName
}
